import { useQuery } from '@tanstack/vue-query';
import { employeeDashboardService } from '@/api/employee-dashboard.service';

export const useEmployeeDashboardSummary = () =>
  useQuery({
    queryKey: ['employee-dashboard'],
    queryFn: () => employeeDashboardService.getSummary(),
  });
